import * as types from './types'
import TransactionsResource from '@/common/resources/Transactions'

export const actions = {
	getOperations ({ commit }) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			commit(types.CLEAR_OPERATIONS)
			TransactionsResource.getOperations().then((result) => {
				if (result.data.success) {
					result.data.missions.forEach((operation) => {
						commit(types.ADD_OPERATION, operation)
					})
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue pendant la récupération des opérations'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	getOperation ({ commit }, id) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			TransactionsResource.getOperation(id).then((result) => {
				if (result.data.success) {
					commit(types.REPLACE_OPERATION, result.data.missions[0])
					commit('LOADER_OUT')
					resolve(result.data.missions[0])
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue pendant la récupération de l\'opération ' + id))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	createOperation ({ commit }, operation) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			TransactionsResource.postOperation({
				user_id: operation.client.id,
				advisor_id: operation.advisor.id,
				title: operation.name,
				contract_ref: operation.contract,
				total_value: operation.amount.value,
				currency: operation.amount.currency,
				type: operation.type,
				description: operation.description
			}).then((result) => {
				if (result.data.success) {
					commit(types.ADD_OPERATION, result.data.mission)
					commit('LOADER_OUT')
					resolve(result.data.mission)
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue pendant la création de l\'opération'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	patchOperation ({ commit }, operation) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			TransactionsResource.updateOperation(operation.id, {
				user_id: operation.client.id,
				advisor_id: operation.advisor.id,
				title: operation.name,
				contract_ref: operation.contract,
				total_value: operation.amount.value,
				currency: operation.amount.currency,
				type: operation.type,
				description: operation.description
			}).then((result) => {
				if (result.data.success) {
					commit(types.REPLACE_OPERATION, result.data.mission)
					commit('LOADER_OUT')
					resolve(result.data.mission)
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue pendant la création de l\'opération'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	getContracts ({ commit }) {
		commit(types.CLEAR_CONTRACTS)
		commit('LOADER_IN')
		TransactionsResource.getContracts().then((result) => {
			if (result.data.success) {
				commit('LOADER_OUT')
				result.data.contracts.forEach((contract) => {
					commit(types.ADD_CONTRACT, contract)
				})
			} else {
				commit('LOADER_OUT')
			}
		}).catch(() => {
			commit('LOADER_OUT')
		})
	},
	addContract ({ commit }, contract) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			TransactionsResource.createContract(contract).then((result) => {
				if (result.data.success) {
					commit(types.ADD_CONTRACT, result.data.contract)
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue à l\'ajout d\'un contrat'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(new Error(error))
			})
		})
	},
	addProduct ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			TransactionsResource.createProduct(data.product).then((result) => {
				if (result.data.success) {
					commit(types.ADD_PRODUCT_TO_CONTRACT, {
						product: result.data.product,
						contractId: data.contractId
					})
					return TransactionsResource.linkProductToContract(data.contractId, result.data.product.id)
				} else {
					commit('LOADER_OUT')
					reject(new Error('new Error while creating the product'))
				}
			}).then((result) => {
				if (result.data.success) {
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject(new Error('new Error while linking product to contract'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	addProductToMission ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			TransactionsResource.addProductToMission(data).then((result) => {
				if (result.data.success) {
					commit(types.ADD_PRODUCT_TO_OPERATION, result.data.mission_contract_product)
					commit('LOADER_OUT')
					resolve(result.data.mission_contract_product)
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue à l\'ajout du produit à la mission'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	editProductFromMission ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			TransactionsResource.editProductFromMission(data.product).then((result) => {
				if (result.data.success) {
					commit(types.EDIT_PRODUCT_FROM_MISSION, result.data.mission_contract_product)
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue pendant l\'édition d\'un produit'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(new Error(error))
			})
		})
	},
	removeProductFromMission ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			TransactionsResource.removeProductFromMission(data.product.id).then((result) => {
				if (result.data.success) {
					commit(types.REMOVE_PRODUCT_FROM_OPERATION, data)
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue pendant la suppression d\'un produit'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/common/store/Transactions/actions.js